module.exports = __webpack_public_path__ + "img/icon-copy-light.494ea0f1.svg";